export default {
  label: 'Campaigns',
  placeholder: 'All',
  items: {
    all: 'All',
    onlyScheduled: 'Only Scheduled',
  },
};
